import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _ProcessPropertiesItem, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { BasicTable } from "../../theme/Component/BasicTable";
import { DropDown } from "../../theme/Component/DropDown";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import usePaginator from "../../theme/Component/usePaginator";
import { SelectProcessTypeConstants } from "./SelectProcessTypeConstants";

interface ComponentData {
    isModal?: boolean;
    _onChange?: Function;
}

const RECORDS_PER_PAGE = 15;

export const ProcessPropertiesItem = ({ isModal, _onChange }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista, validateForm, isMissing, isRequired, addRequiredFields } = useDataBean(_ProcessPropertiesItem);
    const paginator = usePaginator();

    const [regex, setRegex] = useState<string>("");
    const [processType, setProcessType] = useState<number>(0);
    const [processPropertiesProcessType, setProcessPropertiesProcessType] = useState<number>(0);
    const [reloadProperties, setReloadProperties] = useState<boolean>(false);
    const [processProperties, setProcessProperties] = useState<Record<string, any>>({});

    const modal = useModal("", MODAL_md);
    const modalProcessProperties = useModal("Consultar Propiedades por Proceso", MODAL_md);
    const modalProcessPropertiesResult = useModal("Resultado Propiedades por Proceso", MODAL_LG);

    useEffect(() => {
        addRequiredFields(["ProcessType", "Name", "PropertyName", "ReturnClassForName"]);
    }, []);

    useEffect(() => {
        if (processType) {
            getLista();
        } else {
            setLista([]);
            setProcessProperties({});
        }
    }, [processType, paginator.page]);

    const getLista = () => {
        if (!processType) {
            toast.warning("Debe seleccionar un tipo de proceso");
            return;
        }

        instance.getProcessPropertiesItemCatalog(processType, regex, paginator.page, RECORDS_PER_PAGE).then(
            (resp: any) => {
                paginator.setPages(resp.NumberOfPages ?? 0);
                paginator.setRecords((resp.NumberOfPages ?? 0) * RECORDS_PER_PAGE);
                setLista(resp.List ?? []);
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const getProcessProperties = () => {
        if (!processPropertiesProcessType) {
            toast.warning("Debe seleccionar un tipo de actividad");
            return;
        }

        instance.getProcessProperties(processPropertiesProcessType, reloadProperties).then(
            (resp: any) => {
                setProcessProperties(resp?.DataBeanProperties ?? resp ?? {});
                modalProcessProperties.close();
                modalProcessPropertiesResult.open();
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const search = () => {
        if (paginator.page !== 1) {
            paginator.setPage(1);
            return;
        }

        getLista();
    };

    const create = () => {
        if (!processType) {
            toast.warning("Debe seleccionar un tipo de proceso");
            return;
        }

        setBean({
            ProcessType: processType,
            Name: "",
            PropertyName: "",
            EditorClassForName: "",
            EditorPropertyName: "",
            ReturnClassForName: "",
            PropertyDefaultValue: "",
        });
        modal.open("Agregar Propiedad de Proceso");
    };

    const saveItem = () => {
        if (!bean.ProcessType) {
            toast.error("Debe seleccionar un tipo de proceso");
            return;
        }

        if (!validateForm()) {
            toast.error("Faltan campos obligatorios por diligenciar");
            return;
        }

        addItem();
    };

    const addItem = () => {
        instance.addProcessPropertiesItem(
            Number(bean.ProcessType),
            bean.Name,
            bean.PropertyName,
            bean.EditorClassForName,
            bean.EditorPropertyName,
            bean.ReturnClassForName,
            bean.PropertyDefaultValue
        ).then(
            () => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const setValue = (e: any) => {
        _onChange?.(e);
        setBean(e);
    };

    const head = [
        { title: "ID", property: "IDProcessPropertiesItem", visible: true },
        { title: "Tipo de Proceso", property: "ProcessTypeName", visible: true },
        { title: "Nombre", property: "Name", visible: true },
        { title: "Descripcion", property: "Description", visible: true },
        { title: "Nombre Propiedad", property: "PropertyName", visible: true },
        { title: "Clase Propiedad", property: "ReturnClassForName", visible: true },
        { title: "Valor por Defecto", property: "PropertyDefaultValue", visible: true },
        { title: "Clase Editor", property: "EditorClassForName", visible: true },
        { title: "Propiedad Editor", property: "EditorPropertyName", visible: true },
    ];

    const iconButtonsItem = [
        { nombre: "Agregar", visible: _single.canCreate(), icono: "ri-file-add-line", evento: create }
    ];

    const openProcessProperties = () => {
        if (!processType) {
            toast.warning("Debe seleccionar un tipo de proceso");
            return;
        }

        setProcessPropertiesProcessType(processType);
        setProcessProperties({});
        modalProcessProperties.open();
    };

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
            </div>
        );
    };

    const actionsDropDown = [
        { id: 1, name: "Propiedades por Proceso", permiso: null, activo: true },
    ];

    const actions = (e: any) => {
        if (e.id === 1) {
            openProcessProperties();
        }
    };

    const baseComponent = () => {
        return (
            <>
                <div className="row">
                    <div className="col-md-4">
                        <SelectProcessTypeConstants
                            idSelector={processType}
                            onChange={setProcessType}
                            required
                            hasError={!processType}
                            selectFirst
                        />
                    </div>
                    <div className="col-md-4">
                        <label>Busqueda por Texto</label>
                        <input type="text" className="form-control" value={regex} onChange={(e) => { setRegex(e.target.value); }} />
                    </div>

                    <div className="col-md-2">
                        <BasicButton icon="ri-search-line" useMargin eventClick={search}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable
                            body={lista}
                            head={head}
                            rowSet={setValue}
                            headButtons={buttons()}
                            iconButtons={iconButtonsItem}
                            records={paginator}
                        />
                    </div>

                    <div className="col-md-12">
                        <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={saveItem}>
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectProcessTypeConstants
                                        idSelector={bean.ProcessType ?? processType}
                                        onChange={(e: number) => { setBean({ ...bean, ProcessType: e }); }}
                                        required={isRequired("ProcessType")}
                                        hasError={isMissing("ProcessType")}
                                        disabled={!!bean.IDProcessPropertiesItem}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className={`${isMissing("Name") ? "has-error" : ""}`}>Nombre {isRequired("Name") ? <span className="text-danger">*</span> : ""}</label>
                                    <input disabled={!!bean.IDProcessPropertiesItem} className="form-control" type="text" value={bean.Name ?? ""} onChange={(e) => { setBean({ ...bean, Name: e.target.value }); }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripcion</label>
                                    <textarea className="form-control" value={bean.Description ?? ""} onChange={(e) => { setBean({ ...bean, Description: e.target.value }); }} />
                                </div>
                                <div className="col-md-6">
                                    <label className={`${isMissing("PropertyName") ? "has-error" : ""}`}>Nombre Propiedad {isRequired("PropertyName") ? <span className="text-danger">*</span> : ""}</label>
                                    <input disabled={!!bean.IDProcessPropertiesItem} className="form-control" type="text" value={bean.PropertyName ?? ""} onChange={(e) => { setBean({ ...bean, PropertyName: e.target.value }); }} />
                                </div>
                                <div className="col-md-6">
                                    <label className={`${isMissing("ReturnClassForName") ? "has-error" : ""}`}>Clase Propiedad {isRequired("ReturnClassForName") ? <span className="text-danger">*</span> : ""}</label>
                                    <input disabled={!!bean.IDProcessPropertiesItem} className="form-control" type="text" value={bean.ReturnClassForName ?? ""} onChange={(e) => { setBean({ ...bean, ReturnClassForName: e.target.value }); }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Valor por Defecto</label>
                                    <input className="form-control" type="text" value={bean.PropertyDefaultValue ?? ""} onChange={(e) => { setBean({ ...bean, PropertyDefaultValue: e.target.value }); }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Clase Editor</label>
                                    <input className="form-control" type="text" value={bean.EditorClassForName ?? ""} onChange={(e) => { setBean({ ...bean, EditorClassForName: e.target.value }); }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Propiedad Editor</label>
                                    <input className="form-control" type="text" value={bean.EditorPropertyName ?? ""} onChange={(e) => { setBean({ ...bean, EditorPropertyName: e.target.value }); }} />
                                </div>
                            </div>
                        </Modal>

                        <Modal modal={modalProcessProperties.modal} updateModal={modalProcessProperties.setModal} eventModal={getProcessProperties} onSubmitLabel="Consultar">
                            <div className="row">
                                <div className="col-md-12">
                                    <SelectProcessTypeConstants
                                        idSelector={processPropertiesProcessType}
                                        onChange={(e: number) => {
                                            setProcessPropertiesProcessType(e);
                                            setProcessProperties({});
                                        }}
                                        label="Tipo de Actividad"
                                        required
                                        hasError={!processPropertiesProcessType}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <BasicSwitch
                                        estado={reloadProperties}
                                        eventChange={setReloadProperties}
                                        label="Recargar de Base de Datos"
                                    />
                                </div>
                            </div>
                        </Modal>

                        <Modal modal={modalProcessPropertiesResult.modal} updateModal={modalProcessPropertiesResult.setModal}>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <div className="mt-2">
                                        {Object.entries(processProperties).length > 0 ?
                                            <table className="table table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>Propiedad</th>
                                                        <th>Valor</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(processProperties).map(([name, value]) => (
                                                        <tr key={name}>
                                                            <td><strong>{name}</strong></td>
                                                            <td>{value === null || value === undefined ? "" : String(value)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            :
                                            <span>No se encontraron propiedades.</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Propiedades de Proceso">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    );
};
